import http from './http';

/* Actions */

const createAnnouncement = (data, headers) => http.post(`/announcement`, data, headers);

const getAnnouncementList = (data, headers) => http.get(`/announcement`, data, headers);

const deleteAnnouncement = (id, headers) =>
  http.delete(`/announcement/${id}`, undefined, headers);

const updateAnnouncement = (id, data, headers) =>
  http.patch(`/announcement/${id}`, data, headers);

const announcement = (headers) => http.get(`/announcement/user`, undefined, headers);

const getAnnouncementUserList = (data, headers) =>
  http.get(`/announcement/user/list`, data, headers);

const haveReadAnnouncement = (ids, headers) =>
  http.patch(
    `/announcement/haveread`,
    {
      ids,
    },
    headers,
  );

const getPromotionStatistics = (data, header) =>
  http.get(`/admin/promotion/statistics`, data, header);
const getStatistics = (headers) => http.get(`/admin/statistics`, undefined, headers);

const getPromotion = (data, headers) => http.get(`/admin/promotion`, data, headers);

const createPromotion = (data, headers) => http.post(`/admin/promotion/create`, data, headers);

const updatePromotion = (data, headers) => http.post(`/admin/promotion/update`, data, headers);
const deletePromotion = (id, headers) => http.delete(`/admin/promotion/delete/${id}`, undefined, headers);
const getPromotionDetails = (data, header) => http.get(`/admin/promotion/details`, data, header);

const createSettlement = (data, headers) => http.post(`/admin/settlement/create`, data, headers);

const getPromoterLists = (headers) => http.get(`/admin/promoter/lists`, undefined, headers);

const getSettlementManageLists = (data, headers) =>
  http.get(`/admin/settlement/manage/lists`, data, headers);

const getSettlementDetailsLists = (data, headers) =>
  http.get(`/admin/settlement/details/lists`, data, headers);

const getPromoterAmount = (data, headers) =>
  http.get(`/admin/promoter/amount/${data}`, undefined, headers);

const getPaymentLists = (data, headers) => http.get(`/admin/payment/lists`, data, headers);

const getUserManage = (data, headers) => http.get(`/admin/users/company`, data, headers);

const getUserManageDetails = (data, headers) =>
  http.get(`/admin/users/company/details`, data, headers);

const getUserFunctionActions = (data, headers) =>
  http.get(`/admin/users/function/actions`, data, headers);

const updateUserFunction = (data, headers) =>
  http.patch(`/admin/users/function/update`, data, headers);

const adminUsersCompanyUpdate = (data, headers) =>
  http.patch(`/admin/users/company/update`, data, headers).then((body) => ({
    ...body,
  }));

const getAdminUsersCompanyActions = (data, headers) =>
  http.get(`/admin/users/company/actions`, data, headers).then((body) => ({
    ...body,
  }));

const getPayActions = (id, headers) =>
  http.get(`/admin/payment/actions/${id}`, headers).then((body) => ({
    ...body,
  }));

const findSupportName = (data, headers) => http.get('/support/find', data, headers);

const createSupport = (data, headers) => http.post('/support/create', data, headers);

const getSupport = (data, headers) => http.get('/support', data, headers);

const createAccessToken = (data, headers) => http.post('/access-tokens', data, headers);

const deleteCurrentAccessToken = (headers) =>
  http.delete('/access-tokens/me', undefined, headers);

const getCurrentUser = (headers) => http.get('/users/me', undefined, headers);


export default {
  getCurrentUser,
  createAccessToken,
  deleteCurrentAccessToken,
  findSupportName,
  createSupport,
  getSupport,
  getAdminUsersCompanyActions,
  adminUsersCompanyUpdate,
  updateUserFunction,
  getUserFunctionActions,
  getUserManageDetails,
  getUserManage,
  getPaymentLists,
  getPromotionDetails,
  getSettlementDetailsLists,
  getPromoterAmount,
  getSettlementManageLists,
  getPromoterLists,
  createSettlement,
  createPromotion,
  getStatistics,
  getPromotionStatistics,
  createAnnouncement,
  getAnnouncementList,
  updateAnnouncement,
  deleteAnnouncement,
  announcement,
  haveReadAnnouncement,
  getAnnouncementUserList,
  getPromotion,
  updatePromotion,
  deletePromotion,
  getPayActions,
};
